<div class="cell auto cell-block-y simulationLaunch">
    <div class="simulationLaunch-header">
        <h2 class="simulationLaunch-header-title">
            <span [i18nKey]="'simulation.launch.title'"></span>
            <p class="periodInfo">
                <kiwi-period [period]="period"></kiwi-period>
            </p>
        </h2>
        <button class="button simulationLaunch-header-button"
                (click)="showSimulationConfirmationPopup()"
                [disabled]="!simulationLaunchButtonActive">
            <i class="fas fa-cogs buttonSimulation-icon"></i> <span [i18nKey]="'simulation.launch.start'"></span></button>
        <div class="simulationLaunch-header-illu"></div>
    </div>
    <div class="simulationHistory" *ngIf="simulatedPeriods && simulatedPeriods.length > 0">
        <h2 class="simulationHistory-title"[i18nKey]="'simulation.launch.simulation.history'"></h2>
        <div class="simulationHistory-item" *ngFor="let simulatedPeriod of simulatedPeriods">
            <span class="simulationHistory-item-period"><span [i18nKey]="'simulation.launch.simulated.period'"></span> <kiwi-period
                [period]="simulatedPeriod.period"></kiwi-period></span>
            <span class="simulationHistory-item-creation">
                <span [i18nKey]="'simulation.launch.simulation.launched.by'"></span>
                <strong>{{simulatedPeriod.simulatedBy.firstName}}</strong>
                <strong> {{simulatedPeriod.simulatedBy.lastName}}</strong>
                <span [i18nKey]="'simulation.launch.simulated.on'"></span>
                <strong>{{simulatedPeriod.simulationDate | date:'short':'':'fr-FR'}}</strong>.
            </span>
        </div>
    </div>
</div>
